import { reverse } from "lodash-es";

import { BeMappedNode } from "src/constants/NodeDataTypes";
import { NODE_TYPE } from "src/constants/NodeTypes";
import {
  DataShape,
  RowShape,
  RowStatusType,
} from "src/dataTable/DetailedView/tabs/types";

export const hasNodeAccessedFields = (node: BeMappedNode) => {
  return ![NODE_TYPE.OUTPUT_NODE, NODE_TYPE.INPUT_NODE].includes(node.type);
};

export const buildIterationRows = (
  inputList: DataShape[] | undefined,
  outputList: DataShape[] | undefined,
  pendingItem: DataShape | undefined,
  status: RowStatusType,
): RowShape[] => {
  if (!inputList || !outputList) {
    return [];
  }

  const isObjectList = inputList.every((item) => typeof item === "object");
  const rows = inputList
    .map((inputItem, index) => {
      const outputItem = outputList?.[index] as Record<string, string | number>;

      if (outputItem) {
        if (isObjectList) {
          return {
            index,
            input: inputItem,
            output: outputItem,
            type: "success",
          };
        } else {
          return {
            index,
            input: { item: inputItem },
            output: outputItem,
            type: "success",
          };
        }
      } else if (status === "ignored" && index < outputList.length + 1) {
        return {
          index,
          input: { item: inputItem },
          output: {},
          type: "ignored",
        };
      }

      return false;
    })
    .filter(Boolean) as RowShape[];

  // pending decision
  if (inputList.length > outputList.length && pendingItem !== undefined) {
    rows.push({
      index: outputList.length,
      input:
        typeof pendingItem === "object" ? pendingItem : { item: pendingItem },
      output: {},
      type: status === "failure" ? "failure" : "pending",
    });

    const listDiff = inputList.length - outputList.length;
    if (status === "pending" && listDiff > 1) {
      rows.push({
        index: "...",
        input: {},
        output: {},
        type: "skeleton",
      });

      rows.push({
        index: inputList.length - 1,
        input: {},
        output: {},
        type: "skeleton",
      });
    }
  }

  return reverse(rows);
};
